var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEyeClosed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_eye_closed_24px",
    "data-name": "icon/eye closed_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3927",
    "data-name": "Path 3927",
    d: "M1013.483,516.916h0a21.862,21.862,0,0,0-2.623-3.005l.5-.5a.75.75,0,1,0-1.055-1.066l-.584.579-.007-.006-1.066,1.056.007.006-2.263,2.241-.005-.007-4.383,4.341.008.005-2.075,2.056-.008-.005-1.074,1.065.007.005-.418.414a.75.75,0,1,0,1.055,1.066l.65-.644a8.059,8.059,0,0,0,3.959,1.143c4.382,0,8.013-4.376,9.371-6.258A2.235,2.235,0,0,0,1013.483,516.916Zm-1.217,1.608c-1.222,1.7-4.465,5.635-8.154,5.635a6.347,6.347,0,0,1-2.849-.743l2.25-2.229a3.026,3.026,0,0,0,.4.035,3.125,3.125,0,0,0,3.114-3.136,3.027,3.027,0,0,0-.029-.346l2.808-2.781a20.546,20.546,0,0,1,2.465,2.835A.742.742,0,0,1,1012.266,518.524Zm-16.308,0a.742.742,0,0,1,0-.73c1.222-1.694,4.466-5.635,8.154-5.635a6.648,6.648,0,0,1,3.27.961l1.09-1.08a8.338,8.338,0,0,0-4.36-1.381c-4.38,0-8.013,4.375-9.371,6.257a2.235,2.235,0,0,0,0,2.485,21.517,21.517,0,0,0,2.951,3.318l1.064-1.054A20.186,20.186,0,0,1,995.958,518.524Zm4.836-.438a3.128,3.128,0,0,0,.279,1.284l4.153-4.114a3.067,3.067,0,0,0-1.318-.3A3.125,3.125,0,0,0,1000.794,518.086Z",
    transform: "translate(-992.112 -506.159)",
    fill: "#101820"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeClosed);
export default __webpack_public_path__ + "static/media/icon_eye_closed.83c471a6f4d92c374fcfd005214c5adf.svg";
export { ForwardRef as ReactComponent };